import React from 'react';
import Amex from '~/assets/img/cartoes/amex.svg';
import Banescard from '~/assets/img/cartoes/banescard.svg';
import Cabal from '~/assets/img/cartoes/cabal.svg';
import CartaoMais from '~/assets/img/cartoes/cartao_mais.svg';
import Construcard from '~/assets/img/cartoes/construcard.svg';
import Coopercard from '~/assets/img/cartoes/cooper_card.svg';
import Credz from '~/assets/img/cartoes/credz.svg';
import Dinners from '~/assets/img/cartoes/dinners.svg';
import Elo from '~/assets/img/cartoes/elo.svg';
import EloDebito from '~/assets/img/cartoes/elo_debito.svg';
import Greencard from '~/assets/img/cartoes/greencard.svg';
import Hipercard from '~/assets/img/cartoes/hipercard.svg';
import Jcb from '~/assets/img/cartoes/j.c.b.svg';
import Lucree from '~/assets/img/cartoes/lucree.svg';
import Mastercard from '~/assets/img/cartoes/mastercard.svg';
import Sodexo from '~/assets/img/cartoes/sodexo.svg';
import Sorocred from '~/assets/img/cartoes/sorocred.svg';
import Ticket from '~/assets/img/cartoes/ticket.svg';
import Up from '~/assets/img/cartoes/up.svg';
import Valecard from '~/assets/img/cartoes/valecard.svg';
import VisaElectron from '~/assets/img/cartoes/visa_electron.svg';
import Visa from '~/assets/img/cartoes/visa.svg';
import Vr from '~/assets/img/cartoes/vr.svg';

import { Bandeira } from './styles';

export function Cartoes(props) {
	const { cartao } = props;
	// switch (cartao.toLowerCase()) {
	switch (cartao) {
		case 'amex':
			return <Bandeira alt={cartao} src={Amex} />;
		case 'amex credito':
			return <Bandeira alt={cartao} src={Amex} />;
		case 'banescard':
			return <Bandeira alt={cartao} src={Banescard} />;
		case 'cabal':
			return <Bandeira alt={cartao} src={Cabal} />;
		case 'cartaomais':
			return <Bandeira alt={cartao} src={CartaoMais} />;
		case 'cartao mais':
			return <Bandeira alt={cartao} src={CartaoMais} />;
		case 'construcard':
			return <Bandeira alt={cartao} src={Construcard} />;
		case 'coopercard':
			return <Bandeira alt={cartao} src={Coopercard} />;
		case 'cooper card':
			return <Bandeira alt={cartao} src={Coopercard} />;
		case 'credz':
			return <Bandeira alt={cartao} src={Credz} />;
		case 'dinners':
			return <Bandeira alt={cartao} src={Dinners} />;
		case 'elo':
			return <Bandeira alt={cartao} src={Elo} />;
		case 'elo debito':
			return <Bandeira alt={cartao} src={EloDebito} />;
		case 'greencard':
			return <Bandeira alt={cartao} src={Greencard} />;
		case 'hipercard':
			return <Bandeira alt={cartao} src={Hipercard} />;
		case 'hiper':
			return <Bandeira alt={cartao} src={Hipercard} />;
		case 'jcb':
			return <Bandeira alt={cartao} src={Jcb} />;
		case 'j.c.b.':
			return <Bandeira alt={cartao} src={Jcb} />;
		case 'maestro':
			// return <Bandeira alt={cartao} src={Maestro} />;
			return <Bandeira alt={cartao} src={Mastercard} />;
		case 'master':
			// return <Bandeira alt={cartao} src={Maestro} />;
			return <Bandeira alt={cartao} src={Mastercard} />;
		case 'mastercard':
			return <Bandeira alt={cartao} src={Mastercard} />;
		case 'sodexo':
			return <Bandeira alt={cartao} src={Sodexo} />;
		case 'sorocred':
			return <Bandeira alt={cartao} src={Sorocred} />;
		case 'ticket':
			return <Bandeira alt={cartao} src={Ticket} />;
		case 'up':
			return <Bandeira alt={cartao} src={Up} />;
		case 'valecard':
			return <Bandeira alt={cartao} src={Valecard} />;
		case 'visa':
			return <Bandeira alt={cartao} src={Visa} />;
		case 'visa electron':
			return <Bandeira alt={cartao} src={VisaElectron} />;
		case 'vr':
			return <Bandeira alt={cartao} src={Vr} />;
		case null:
			return <Bandeira alt={cartao} src={Lucree} />;
		default:
			return <>{cartao}</>;
	}
}
